export default "__VITE_ASSET__000841fc__"